import {fetchWithTimeout} from "../../util/helperFunctions";
import moment from "moment/moment";
import uuid from "uuid";
import {addOrUpdate, getDB} from "../../util/indexedDBConnector";
import CTR from "../../util/receiptTemplate";
import {addErrorAlert, addProduct, findProduct, setLoading, setPenniesDonation} from "../../redux/actions";

export const getPenniesConf = (state) => {
    let conf = window?.AppConf?.pennies || {};
    if(
        typeof conf.url === "undefined" ||
        typeof conf.token === "undefined" ||
        typeof conf.item === "undefined" ||
        typeof conf.merchantID === "undefined"
    ){
        return false;
    }
    if(conf?.useProxy){
        conf.mainUrl = state.rootReducer.erplyServiceEndpoints.goerp.url.split("/api")[0] + "/int/pennies-sync/proxy";
        conf.clientCode = state.rootReducer.user.clientCode;
        conf.sessionKey = state.rootReducer.user.sessionKey;
    }else{
        conf.mainUrl = conf.url;
    }
    return conf;
}

export const getStoreID = (state) => {
    return getPenniesConf(state)?.storeID ?? state.rootReducer.warehouse.code
}

export const addPenniesItem = (dispatch, state, donationAmount) => {
    return new Promise((resolve, reject) => {
        let conf = getPenniesConf(state);
        if(conf === false){
            reject("No pennies conf");
            return;
        }

        dispatch(setLoading(true));
        dispatch(findProduct(conf.item, state.rootReducer.warehouse.warehouseID, state.rootReducer.pos.pointOfSaleID, donationAmount, (product) => {
            setTimeout(resolve, 1);
            dispatch(setLoading(false));
            product.setNotDiscountable();
            product.setAmountNotEditable();
            return addProduct(product);
        }, (code, error) => {
            reject();
            dispatch(setLoading(false));
            return addErrorAlert("Could not find charity item, please check the configuration!");
        }));
    })
}

export const onTransactionSuccess = (state) => {
    let pennies = state.rootReducer.pennies;
    if(pennies.added !== false){
        let dateTime = moment();
        dateTime.tz(state.rootReducer.erplyConf.timezone);
        let id = CTR.lastReceiptNumber !== false ? CTR.lastReceiptNumber : uuid.v4();
        API.donation(dateTime.format("YYYY-MM-DD\THH:mm:ss"), pennies.added, getStoreID(state), id, state).then((response) => {
            console.log("Pennies donation success", {response});
        }, ({requestData, response}) => {
            console.log("Pennies donation failed", {response});
            getDB(state.rootReducer.user.clientCode).then(() => {
                addOrUpdate("saveIntegrationLog", {
                    application: "pennies",
                    requestData,
                    retries: 0,
                    status: 0
                }).then(() => {}, (e) => {
                    console.log('addOrUpdate record failed', {requestData, e});
                });
            })
        });
    }
}

const API = {
    sendRequest: (state, method, request, urlParams, data, timeout) => {
        return new Promise((resolve, reject) => {
            let conf = getPenniesConf(state);
            if (conf === false) {
                reject("Pennies conf missing");
                return;
            }

            let requestParams = {
                method,
                headers: {
                    "Access-token": conf.token
                },
                timeout: (timeout ?? (conf?.timeout ?? 5)) * 1000
            };

            const urlSearchParams = new URLSearchParams({
                format: "json",
                ...urlParams
            });

            if(method === "POST"){
                requestParams.body = new URLSearchParams(data);
                requestParams.headers["Content-Type"] = "application/x-www-form-urlencoded"
            }

            let url = conf.url + (conf.url.endsWith("/") ? "" : "/");
            let requestUrl = `${url}${request}/${conf.merchantID}?${urlSearchParams.toString()}`;
            if(conf?.useProxy){
                requestUrl = `${conf.mainUrl}?u=${btoa(requestUrl)}`;
                let proxyRequestBody = {
                    method: requestParams.method,
                    headers: requestParams.headers
                }
                if(requestParams.method === "POST"){
                    proxyRequestBody.body = requestParams.body.toString();
                }
                requestParams.body = JSON.stringify(proxyRequestBody);
                requestParams.method = "POST";
                requestParams.headers = {
                    clientCode: conf.clientCode,
                    sessionKey: conf.sessionKey
                }
            }
            fetchWithTimeout(requestUrl, requestParams).then((response) => {
                let result = response.json();
                if(response.status === 200 || (response.status === 409 && result.error === "duplicate")){
                    resolve(result);
                }else{
                    reject(result);
                }
            }, reject);
        });
    },
    calculation: (amount, storeID, state) => {
        return new Promise((resolve, reject) => {
            API.sendRequest(state, "GET", "donation/calculation", {amount, store_id: storeID}).then(resolve, reject);
        });
    },
    donation: (dateTime, amount, storeID, transactionID, state, retry = 0) => {
        return new Promise((resolve, reject) => {
            let urlParams = {};
            if(retry > 0){
                urlParams.retry = "true";
            }
            let requestData = {
                donation_date_time: dateTime,
                amount,
                store_id: storeID,
                transaction_id: transactionID
            };

            API.sendRequest(state, "POST", "donation", urlParams, requestData, 10).then(resolve, (response) => {
                if(retry < 3){
                    API.donation(dateTime, amount, storeID, transactionID, state, retry + 1).then(resolve, reject);
                }else{
                    reject({requestData, response});
                }
            });
        });
    }
}

export default API;